import { useTranslation } from 'react-i18next'
import { Modal, AcknowledgeModal } from '@percent/lemonade'

export type CancelOpportunitySuccessModalProps = Readonly<{
  isOpen: boolean
  onClose: () => void
  opportunityName: string
}>

export function CancelOpportunitySuccessModal({ isOpen, onClose }: CancelOpportunitySuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={onClose}>
      <AcknowledgeModal
        title={t('volunteering.actionsMenu.cancelOpportunity.cancelOpportunitySuccessModal.title')}
        result="positive"
        buttonText={t('button.close')}
        handleClose={onClose}
      />
    </Modal>
  )
}
